<style scoped lang="scss" type="text/scss">
    .session-ticket-container {
        padding-right: .5rem;

        .placeholder {
            width: calc(100% + .5rem);
        }
    }
</style>

<template>
    <div class="session-ticket-container">
        <placeholder class="placeholder" v-if="competitions === null || competitions.length === 0">
            未添加主赛事
        </placeholder>
        <session-ticket v-for="competition in competitions" :key="competition.id"
                        :name="competition.name" :year="competition.year_text"
                        :is-main="competition.main === IS_MAIN"
                        :status="competition.status_text"
                        :active="competition.id === currentMainCompetitionId"
                        @click.native="changeCompetition(competition.id)"
        >
        </session-ticket>
    </div>
</template>

<script>
    import Placeholder from '../../../components/placeholder/index';
    import SessionTicket from './session-ticket';
    import {COMPETITION_MAIN_OR_NOT_VALUE_MAP} from '../../../constant/competition-main-or-not';
    import _ from 'lodash';

    export default {
        name: '',
        components: {
            Placeholder,
            SessionTicket
        },
        created () {
            this.loadMainCompetitions();
        },
        data () {
            return {
                IS_MAIN: COMPETITION_MAIN_OR_NOT_VALUE_MAP.YES
            };
        },
        computed: {
            competitions () {
                return this.$store.state.competition.mainCompetitions;
            },
            currentMainCompetitionId () {
                return this.$store.state.competition.currentMainCompetitionId;
            }
        },
        watch: {
            competitions: {
                immediate: true,
                handler (competitions) {
                    if (competitions !== null && competitions.length > 0) {
                        this.$store.commit('competition/updateCurrentMainCompetitionId', _.get(competitions[0], 'id'));
                    }
                }
            }
        },
        methods: {
            loadMainCompetitions () {
                this.$store.dispatch('competition/loadMainCompetitions').then();
            },
            changeCompetition (id) {
                this.$store.commit('competition/updateCurrentMainCompetitionId', id);
            }
        }
    };
</script>
